"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importStar(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Slider = props => {
    const { value, minValue, maxValue, valueLabels, largeValueLabels, hideValueBar, step, onChange, onDragEnd, className, disabled } = props, remainingProps = tslib_1.__rest(props, ["value", "minValue", "maxValue", "valueLabels", "largeValueLabels", "hideValueBar", "step", "onChange", "onDragEnd", "className", "disabled"]);
    const [currentValue, setCurrentValue] = (0, react_1.useState)(value ? value : minValue);
    const [isChanging, setIsChanging] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (value >= minValue && value <= maxValue) {
            setCurrentValue(value);
        }
    }, [value, minValue, maxValue]);
    const handleChange = event => {
        const newValue = parseInt(event.target.value, 10);
        setCurrentValue(newValue);
        setIsChanging(true);
        onChange(newValue);
    };
    const onMouseUp = () => {
        setIsChanging(false);
        onDragEnd(currentValue);
    };
    const onMouseDown = () => {
        setIsChanging(true);
    };
    const wrapperClassNames = (0, classnames_1.default)('range-slider', disabled && 'disabled', valueLabels && 'show-value-labels', hideValueBar && 'hide-value-bar', largeValueLabels && 'large-value-labels', className && className);
    const trackWidth = (100 * (currentValue - minValue)) / (maxValue - minValue);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, remainingProps, { className: wrapperClassNames }, { children: [(0, jsx_runtime_1.jsx)("div", { className: 'range-whole-track' }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'range-track', style: { width: `${trackWidth}%` } }, { children: valueLabels && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'range-value' }, { children: currentValue })) })), (0, jsx_runtime_1.jsx)("input", { className: `${isChanging ? 'changing' : ''}`, value: currentValue, min: minValue, max: maxValue, step: step, type: 'range', onChange: handleChange, onMouseDown: onMouseDown, onMouseUp: onMouseUp })] })));
};
Slider.defaultProps = {
    step: 1,
    value: 0,
    minValue: 0,
    maxValue: Number.MAX_VALUE,
    valueLabels: false,
    hideValueBar: false,
    disabled: false,
    onChange: () => { },
    onDragEnd: () => { },
};
Slider.propTypes = {
    value: prop_types_1.default.number,
    minValue: prop_types_1.default.number.isRequired,
    maxValue: prop_types_1.default.number.isRequired,
    valueLabels: prop_types_1.default.bool,
    largeValueLabels: prop_types_1.default.bool,
    hideValueBar: prop_types_1.default.bool,
    step: prop_types_1.default.number,
    onChange: prop_types_1.default.func,
    onDragEnd: prop_types_1.default.func,
    className: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
};
exports.default = Slider;
